import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Replaces Blazor's `#blazor-error-ui` bar. Anything that throws during render
 * lands here instead of leaving a blank page behind.
 */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled error:', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="app-error-boundary" role="alert">
        <h1>Oops! Something went sideways.</h1>
        <p>Grab a mojito and try again.</p>
        <button type="button" className="reload" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
